export default __webpack_public_path__ + "static/media/information--lane-control-left-turn--g1.b9518417.png";